import React from 'react';

type Platform = 'instagram' | 'tiktok' | 'youtube' | 'snapchat';

interface PlatformIconsProps {
  platforms: Platform[];
  size?: 'sm' | 'md';
}

const platformConfig: Record<Platform, { label: string; color: string; bg: string; initials: string }> = {
  instagram: { label: 'Instagram', color: 'text-pink-400', bg: 'bg-pink-400/15', initials: 'IG' },
  tiktok: { label: 'TikTok', color: 'text-cyan-400', bg: 'bg-cyan-400/15', initials: 'TK' },
  youtube: { label: 'YouTube', color: 'text-red-400', bg: 'bg-red-400/15', initials: 'YT' },
  snapchat: { label: 'Snapchat', color: 'text-yellow-400', bg: 'bg-yellow-400/15', initials: 'SC' },
};

export default function PlatformIcons({ platforms, size = 'md' }: PlatformIconsProps) {
  const sizeClass = size === 'sm' ? 'w-5 h-5 text-xs' : 'w-7 h-7 text-xs';

  return (
    <div className="flex items-center gap-1">
      {platforms.map((platform) => {
        const cfg = platformConfig[platform];
        return (
          <span
            key={`platform-${platform}`}
            className={`${sizeClass} ${cfg.bg} ${cfg.color} rounded-md flex items-center justify-center font-700`}
            title={cfg.label}
          >
            {cfg.initials}
          </span>
        );
      })}
    </div>
  );
}